import { render, staticRenderFns } from "./readfilestructure.vue?vue&type=template&id=caf8fbbc&"
import script from "./readfilestructure.vue?vue&type=script&lang=js&"
export * from "./readfilestructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/other/readfilestructure.vue"
export default component.exports